import { Tooltip } from '@material-ui/core';
import React from 'react';

export default function AddressDetailsPurchase(props: any) {
    const { apiData } = props;
    return (
        <div className="address-box">
            <div className="tooltip-icon">
                <Tooltip title="Address">
                    <img src="/images/tooltip-icon.png" alt="icon" />
                </Tooltip>
            </div>
            <p>
                Address :{' '}
                {Object.values(apiData.address).some((val) => !!val) ? (
                    <span>
                        {apiData?.address?.line1}, {apiData?.address?.line2},{' '}
                        {apiData?.address?.line3}, {apiData?.address?.city},{' '}
                        {apiData?.address?.state}, {apiData?.address?.pincode},
                        {apiData?.address?.country}
                    </span>
                ) : (
                    ''
                )}
            </p>
        </div>
    );
}
